




















import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import { SwStatusInfo } from '@sonicwall/unified-ui-framework/src/shared/sw-status-info';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  components: {
    SwStatusInfo,
  },
})
export default class MswStatusInfo extends SwExtendedVue {

  @State((state: RootStoreState) => state.CoreStoreModule.msgQueue)
  msgQueue: [];

  handleClose(index: number) {
    this.$store.commit('removeMessage', index);
  }

  get getRouteName() {
    return this.$route.path.includes('org-profile');
  }

  @Watch('msgQueue')
  clearQueue() {
    this.msgQueue.forEach((message, index) => {
      console.warn(message);
      setTimeout(() => {
        this.$store.commit('removeMessage', this.msgQueue.length - index - 1);
      }, 5000); // tslint:disable-line
    });
  }
}
